/* PGN Cart drawer — self-contained: intercepts add-to-cart forms, changes lines by item key,
   re-renders through the Section Rendering API (sections=pgn-cart-drawer,cart-icon-bubble). No dependencies.
   "Your 2nd watch, 50% off": up to 6 suggestions (recommendations "related" for the first line, topped up with
   /collections/best-sellers), excluding what is already in the cart; "+ Add" posts to /cart/add.js and keeps the drawer open. */
(function () {
  if (window.__pgnCart) return;
  window.__pgnCart = true;

  var SECTIONS = 'pgn-cart-drawer,cart-icon-bubble';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SYNC_ATTRS = ['class', 'data-pgn-first-product', 'data-pgn-in-cart'];
  var timers = {};
  var lastFocus = null;
  var reco = { key: null, html: '', collapsed: false, cache: {} };

  function drawer() { return document.querySelector('pgn-cart-drawer[data-pgn-cart]'); }
  function isOpen() { var d = drawer(); return !!(d && d.classList.contains('is-open')); }

  function sectionInner(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function render(sections) {
    if (!sections) return;
    var d = drawer();
    if (d && sections['pgn-cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['pgn-cart-drawer'], 'text/html');
      var fresh = doc.querySelector('pgn-cart-drawer');
      if (fresh) {
        var open = d.classList.contains('is-open');
        d.innerHTML = fresh.innerHTML;
        SYNC_ATTRS.forEach(function (a) {
          var v = fresh.getAttribute(a);
          if (v === null) d.removeAttribute(a); else d.setAttribute(a, v);
        });
        if (open) d.classList.add('is-open');
        d.setAttribute('aria-hidden', open ? 'false' : 'true');
      }
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var inner = sectionInner(sections['cart-icon-bubble'], '.shopify-section');
      if (inner !== null) bubble.innerHTML = inner;
    }
    document.dispatchEvent(new CustomEvent('pgn-cart:updated'));
  }

  function refresh() {
    /* Na PDP, "/products/<handle>" com Accept: application/json devolve o JSON do PRODUTO e ignora ?sections=
       (a gaveta não atualizava e mostrava o carrinho do carregamento da página). Pede na raiz, sem esse header,
       e sem cache. */
    return fetch(ROOT + '?sections=' + SECTIONS + '&_=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  function setBusy(on) {
    var d = drawer();
    if (!d) return;
    if (on) d.setAttribute('busy', ''); else d.removeAttribute('busy');
    d.querySelectorAll('[data-pgn-qty-minus],[data-pgn-qty-plus],[data-pgn-remove]').forEach(function (b) { b.disabled = on; });
  }

  function showDrawerError(msg) {
    var d = drawer();
    var el = d && d.querySelector('[data-pgn-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }

  function change(key, qty) {
    clearTimeout(timers[key]);
    delete timers[key];
    setBusy(true);
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: SECTIONS, sections_url: location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (res.ok) { render(res.json.sections); }
        else { return refresh().then(function () { showDrawerError(res.json.message || res.json.description || 'Could not update the cart'); }); }
      })
      .catch(function () { return refresh(); })
      .then(function () { setBusy(false); });
  }

  function queue(key, qty) {
    clearTimeout(timers[key]);
    timers[key] = setTimeout(function () { change(key, qty); }, 250);
  }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pgn-cart-open');
    /* foco na própria gaveta (tabindex=-1), não no X: no celular o X ganhava a moldura de foco do tema */
    setTimeout(function () { try { d.focus({ preventScroll: true }); } catch (e) { d.focus(); } }, 60);
    recoLoad();
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pgn-cart-open');
    if (lastFocus && typeof lastFocus.focus === 'function') { try { lastFocus.focus(); } catch (e) {} }
    lastFocus = null;
  }

  function showFormError(form, msg) {
    var el = form.querySelector('.pgn-cart-error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'pgn-cart-error';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'margin:8px 0 0;font-size:13px;color:#b3261e;';
      form.appendChild(el);
    }
    el.textContent = msg;
  }
  function clearFormError(form) {
    var el = form.querySelector('.pgn-cart-error');
    if (el) el.remove();
  }

  /* ---------- "Your 2nd watch, 50% off" (suggestions) ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var d = drawer();
    var fmt = (d && d.getAttribute('data-pgn-money')) || '${{amount}}';
    var n = (cents || 0) / 100;
    var amount = /amount_no_decimals/.test(fmt) ? String(Math.round(n)) : n.toFixed(2);
    if (/amount_with_comma_separator/.test(fmt)) amount = amount.replace('.', ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount).replace(/<[^>]+>/g, '');
  }
  function sized(url, w) {
    if (!url) return '';
    url = String(url);
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function normRec(p) { /* /recommendations/products.json: prices in cents */
    var v = p.variants && p.variants.length === 1 ? p.variants[0] : null;
    return { id: p.id, title: p.title, url: p.url || (ROOT + 'products/' + p.handle), image: p.featured_image || (p.images && p.images[0]) || '',
      price: p.price || 0, compare: p.compare_at_price || 0, variant: v && v.available !== false ? v.id : null, available: p.available !== false };
  }
  function normCol(p) { /* /collections/<handle>/products.json: prices as strings */
    var v = p.variants && p.variants.length === 1 ? p.variants[0] : null;
    var img = p.images && p.images[0] ? (p.images[0].src || p.images[0]) : '';
    return { id: p.id, title: p.title, url: ROOT + 'products/' + p.handle, image: img,
      price: v ? Math.round(parseFloat(v.price) * 100) : 0, compare: v && v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0,
      variant: v && v.available !== false ? v.id : null, available: !v || v.available !== false };
  }
  function cardHTML(p) {
    var cta = p.variant
      ? '<button type="button" class="pgn-reco__add" data-pgn-reco-add="' + esc(p.variant) + '">+ Add</button>'
      : '<a class="pgn-reco__add" href="' + esc(p.url) + '">View</a>';
    return '<div class="pgn-reco__card"><a class="pgn-reco__link" href="' + esc(p.url) + '">' +
      (p.image ? '<img src="' + esc(sized(p.image, 300)) + '" alt="" width="150" height="150" loading="lazy">' : '') +
      '<span class="pgn-reco__title">' + esc(p.title) + '</span>' +
      '<span class="pgn-reco__price"><span>' + esc(money(p.price)) + '</span>' + (p.compare > p.price ? '<s>' + esc(money(p.compare)) + '</s>' : '') + '</span>' +
      '</a>' + cta + '</div>';
  }
  function getJSON(url) {
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  function recoRender() {
    var d = drawer();
    if (!d) return;
    var has = !!reco.html;
    d.querySelectorAll('[data-pgn-reco-list]').forEach(function (el) { el.innerHTML = reco.html; });
    d.querySelectorAll('[data-pgn-reco],[data-pgn-reco-panel]').forEach(function (el) { el.hidden = !has; });
    var block = d.querySelector('[data-pgn-reco]');
    if (block) {
      block.classList.toggle('is-collapsed', reco.collapsed);
      var t = block.querySelector('[data-pgn-reco-toggle]');
      if (t) { t.textContent = reco.collapsed ? '+' : '−'; t.setAttribute('aria-expanded', reco.collapsed ? 'false' : 'true'); }
    }
  }
  function recoLoad() {
    var d = drawer();
    if (!d) return;
    var first = d.getAttribute('data-pgn-first-product') || '';
    var inCart = (d.getAttribute('data-pgn-in-cart') || '').split(',').filter(Boolean);
    if (!first) { reco.key = 'empty'; reco.html = ''; recoRender(); return; }
    var key = first + ':' + inCart.join(',');
    if (key === reco.key) { recoRender(); return; }
    var related = reco.cache['r:' + first] || (reco.cache['r:' + first] =
      getJSON(ROOT + 'recommendations/products.json?product_id=' + first + '&limit=10&intent=related')
        .then(function (j) { return ((j && j.products) || []).map(normRec); }));
    var best = reco.cache['c:best'] || (reco.cache['c:best'] =
      getJSON(ROOT + 'collections/best-sellers/products.json?limit=30')
        .then(function (j) { return ((j && j.products) || []).map(normCol); }));
    related
      .then(function (rel) { return rel.length >= 8 ? rel : best.then(function (b) { return rel.concat(b); }); })
      .then(function (list) {
        var seen = {};
        var out = list.filter(function (p) {
          if (!p || !p.available || inCart.indexOf(String(p.id)) !== -1 || seen[p.id]) return false;
          seen[p.id] = true;
          return true;
        }).slice(0, 6);
        reco.key = key;
        reco.html = out.map(cardHTML).join('');
        recoRender();
      });
  }
  function recoAdd(variantId, btn) {
    if (btn) btn.disabled = true;
    setBusy(true);
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, sections: SECTIONS, sections_url: location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (res.ok) { render(res.json.sections); }
        else { if (btn) btn.disabled = false; return refresh().then(function () { showDrawerError(res.json.description || res.json.message || 'Could not add this item to your cart'); }); }
      })
      .catch(function () { if (btn) btn.disabled = false; return refresh(); })
      .then(function () { setBusy(false); });
  }
  document.addEventListener('pgn-cart:updated', recoLoad);

  /* 1. ADD TO CART — capture phase so the theme bundle never sees the submit */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (form.hasAttribute('data-pgn-busy')) return;
    var fd = new FormData(form);
    if (!fd.has('id')) {
      var idEl = form.querySelector('[name="id"]');
      if (idEl) fd.append('id', idEl.value);
    }
    fd.append('sections', SECTIONS);
    fd.append('sections_url', location.pathname);
    clearFormError(form);
    form.setAttribute('data-pgn-busy', '');
    var btn = form.querySelector('button[name="add"], [type="submit"]');
    if (btn) btn.setAttribute('aria-disabled', 'true');
    fetch(ROOT + 'cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, json: j }; }); })
      .then(function (res) {
        if (res.ok) { render(res.json.sections); openDrawer(); }
        else { showFormError(form, res.json.description || res.json.message || 'Could not add this item to your cart'); }
      })
      .catch(function () { showFormError(form, 'Could not add this item to your cart'); })
      .then(function () { form.removeAttribute('data-pgn-busy'); if (btn) btn.removeAttribute('aria-disabled'); });
  }, true);

  /* 2. OPEN from the header cart icon — capture so the bundle cannot navigate to /cart */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('#cart-icon-bubble, a[href], [data-pgn-open]');
    if (!a) return;
    var isBubble = a.id === 'cart-icon-bubble' || !!a.closest('#cart-icon-bubble');
    var href = (a.getAttribute('href') || '').split('?')[0].split('#')[0];
    var isCartLink = /\/cart\/?$/.test(href) && !!a.closest('header, .header, .header-wrapper, .shopify-section-group-header-group, #shopify-section-header');
    if (!isBubble && !isCartLink && !a.hasAttribute('data-pgn-open')) return;
    if (!drawer()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openDrawer();
    refresh();
  }, true);

  /* 3-4. QTY / REMOVE / CLOSE / suggestions inside the drawer (delegated, by item key) */
  document.addEventListener('click', function (e) {
    var d = drawer();
    var t = e.target;
    if (!d || !t || !t.closest || !d.contains(t)) return;
    if (t === d || t.closest('[data-pgn-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (t.closest('[data-pgn-reco-toggle]')) { e.preventDefault(); reco.collapsed = !reco.collapsed; recoRender(); return; }
    var addBtn = t.closest('[data-pgn-reco-add]');
    if (addBtn) { e.preventDefault(); recoAdd(addBtn.getAttribute('data-pgn-reco-add'), addBtn); return; }
    var line = t.closest('[data-pgn-key]');
    if (!line) return;
    var key = line.getAttribute('data-pgn-key');
    var input = line.querySelector('[data-pgn-qty-input]');
    var current = input ? parseInt(input.value, 10) : 1;
    if (isNaN(current)) current = 1;
    if (t.closest('[data-pgn-remove]')) { e.preventDefault(); change(key, 0); return; }
    if (t.closest('[data-pgn-qty-minus]')) { e.preventDefault(); var down = Math.max(0, current - 1); if (input) input.value = down; queue(key, down); return; }
    if (t.closest('[data-pgn-qty-plus]')) { e.preventDefault(); var up = current + 1; if (input) input.value = up; queue(key, up); }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-pgn-qty-input]')) return;
    var line = t.closest('[data-pgn-key]');
    if (!line) return;
    var q = parseInt(t.value, 10);
    if (isNaN(q) || q < 0) q = 0;
    t.value = q;
    queue(line.getAttribute('data-pgn-key'), q);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) closeDrawer();
  });

  /* 6. testing hook: ?pgncart=1 opens the drawer on load */
  function boot() {
    if (/(^|[?&])pgncart=1(&|$)/.test(location.search)) openDrawer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  window.__pgnCartApi = { open: openDrawer, close: closeDrawer, refresh: refresh, render: render, change: change, reco: recoLoad };
})();
